var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLoop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.75,25.25 L13.25,25.25 L13.25,12.75 L10.75,12.75 L10.75,25.25 Z M15.75,29 L18.25,29 L18.25,9 L15.75,9 L15.75,29 Z M7,21.5 L9.5,21.5 L9.5,16.5 L7,16.5 L7,21.5 Z M20.75,25.25 L23.25,25.25 L23.25,12.75 L20.75,12.75 L20.75,25.25 Z M24.5,16.5 L24.5,21.5 L27,21.5 L27,16.5 L24.5,16.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1920\\u5BBD\\u5EA6\\u9891\\u5E55-PACKS\\u9875",
    transform: "translate(-1412.000000, -794.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u884C\\u52A8\\u70B9\\u6309\\u94AE\\u5907\\u4EFD-2",
    transform: "translate(1400.000000, 785.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Control/Desktop/Play-Pause/a.-Play-Resting",
    transform: "translate(14.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(23.000000, 0.000000)",
    fill: "#FF651A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 4.125,
    y: 0,
    width: 2.75,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-57",
    transform: "translate(5.500000, 5.500000) rotate(90.000000) translate(-5.500000, -5.500000) ",
    points: "4.125 1.04083409e-15 6.875 1.04083409e-15 6.875 11 4.125 11"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/device/graphicon/device/eq_24px",
    fill: "#FF651A",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4400351,2.47336185 C19.177491,2.16403189 17.8579013,2 16.5,2 C7.38730163,2 0,9.38730163 0,18.5 C0,27.6126984 7.38730163,35 16.5,35 C25.6126984,35 33,27.6126984 33,18.5 C33,16.9911302 32.7974672,15.5295644 32.4181041,14.1410053",
    id: "\\u8DEF\\u5F84",
    stroke: "#FF651A",
    strokeWidth: 3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLoop);
export default __webpack_public_path__ + "static/media/new-loop.097da555.svg";
export { ForwardRef as ReactComponent };